
/**
 * External dependencies
 */
import { get } from 'lodash';

/**
 * Internal dependencies
 */

export const handlers = {}

export default store => next => action => {
    const rv = next(action);

    if (!get(action, 'meta.notices.skip') && handlers.hasOwnProperty(action.type)) {
        const noticeAction = handlers[action.type](action);
        if (noticeAction) {
            store.dispatch(noticeAction);
        }
    }

    return rv;
};